import {
  teamCol,
  confCol,
  yearCol,
  divCol,
  numCol,
  round3Col,
  round2Col,
  round1Col,
  round0Col,
  pctColWithSort,
  warCol,
  sosAdjWarCol,
  opsCol,
} from "./leaderboards/helpers";

const teamBattingBasicStats = [
  numCol("PA", "pa"),
  numCol("AB", "ab"),
];

const teamBattingHittingStats = [
  numCol("H", "h"),
  numCol("1B", "1b"),
  numCol("2B", "2b"),
  numCol("3B", "3b"),
  numCol("HR", "hr"),
  numCol("R", "r"),
  numCol("RBI", "rbi"),
];

const teamBattingBaserunningStats = [
  numCol("SB", "sb"),
  numCol("CS", "cs"),
  pctColWithSort("SB%", "sb_pct"),
];

const teamBattingPlateDiscipline = [
  numCol("BB", "bb"),
  numCol("IBB", "ibb"),
  numCol("HBP", "hbp"),
  numCol("SF", "sf"),
  numCol("SH", "sh"),
  numCol("BFH", "bfh"),
  numCol("SO", "k"),
];

const teamBattingRates = [
  round3Col("BA", "ba", "5rem"),
  round3Col("OBP", "ob_pct", "5rem"),
  round3Col("SLG", "slg_pct", "5rem"),
  opsCol("5rem"),
  round3Col("ISO", "iso", "5rem"),
  round3Col("wOBA", "woba", "5rem"),
];

const teamBattingAdvanced = [
  pctColWithSort("K%", "k_pct"),
  pctColWithSort("BB%", "bb_pct"),
  round2Col("BB/K", "bb_per_k", "5rem"),
  round3Col("BABIP", "babip", "5rem"),
  round1Col("RC", "runs_created", "5rem"),
  round3Col("RC/PA", "rc_per_pa", "6rem"),
  round1Col("wRC", "wrc", "6rem"),
  round1Col("wRAA", "wraa", "6rem"),
  round0Col("wRC+", "wrc_plus", "5rem"),
  round0Col("OPS+", "ops_plus", "5rem"),
];

const teamBattingValue = [
  round1Col("RE24", "rea", "6rem"),
  round1Col("WPA", "wpa", "6rem"),
  round1Col("WPA/LI", "wpa_li", "6rem"),
  round1Col("Clutch", "clutch", "6rem"),
];

const teamBattingWarComponents = [
  round1Col("Batting", "batting", "6rem"),
  round1Col("Base Run", "baserunning", "6rem"),
  round1Col("Pos. Adj", "positional_adjustment", "6rem"),
  round1Col("Lg. Adj", "league_adjustment", "6rem"),
];

const teamBattingOther = [
  numCol("EBT", "ebt"),
  numCol("EBT Opps", "ebt_opps", "7rem"),
  round1Col("wEBT", "webt", "6rem"),
  numCol("GDP", "gdp"),
  numCol("GDP Opps", "gdp_opps", "7rem"),
  round1Col("wGDP", "wgdp", "6rem"),
  round1Col("wSB", "wsb", "6rem"),
];

export function getTeamBattingColumns() {
  return [
    teamCol("10rem"),
    confCol(),
    divCol(),
    yearCol(),
    ...teamBattingBasicStats,
    ...teamBattingHittingStats,
    ...teamBattingBaserunningStats,
    ...teamBattingPlateDiscipline,
    ...teamBattingRates,
    ...teamBattingAdvanced,
    ...teamBattingValue,
    ...teamBattingWarComponents,
    warCol("5rem"),
    sosAdjWarCol("7rem"),
    ...teamBattingOther,
  ];
}
